import './editingPanel.css';

export default function EditingPanel({
  title,
  action,
  onActionChange,
  actions = [],
  topRow,
  grid,
  message,
  onSubmit,
  isDanger = false,
  submitLabel = 'Save',
}) {
  return (
    <div className="editing-panel">
      <div className="editing-panel__header">
        <h2 className="editing-panel__title">{title}</h2>
        {actions.length > 0 && (
          <select
            value={action}
            onChange={(e) => onActionChange(e.target.value)}
            className="editing-panel__select"
            aria-label="Select action"
          >
            {actions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}
      </div>

      {topRow && <div className="editing-panel__row">{topRow}</div>}
      {grid && <div className="editing-panel__grid">{grid}</div>}

      <div className="editing-panel__actions">
        <button
          type="button"
          onClick={onSubmit}
          className={`editing-panel__btn ${
            isDanger ? 'editing-panel__btn--danger' : 'editing-panel__btn--primary'
          }`}
        >
          {submitLabel}
        </button>

        {message && <div className="editing-panel__message" role="status">{message}</div>}
      </div>
    </div>
  );
}
